import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import TRANSLATIONS_IT from "./locale/it.json";
import TRANSLATIONS_EN from "./locale/en.json";
import TRANSLATIONS_FR from "./locale/fr.json";
import TRANSLATIONS_ES from "./locale/es.json";


export default i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      it: {
        translations: TRANSLATIONS_IT
      },
      en: {
        translations: TRANSLATIONS_EN
      },
      fr: {
        translations: TRANSLATIONS_FR
      },
      es: {
        translations: TRANSLATIONS_ES
      }
    },
    
    fallbackLng: "it",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false
    }
  });